import { getSinglePost } from "./postApi";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

const initialState = {
    postDetail: {},
    isLoading: false,
    isError: false,
    error: "",
};

// async thunk
export const fetchSinglepost = createAsyncThunk("post/fetchSinglepost", async (id) => {
    const posts = await getSinglePost(id);
    return posts?.data;
});

const singlePostSlice = createSlice({
    name: "postDetail",
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(fetchSinglepost.pending, (state) => {
                state.isError = false;
                state.isLoading = true;
            })
            .addCase(fetchSinglepost.fulfilled, (state, action) => {
                state.isLoading = false;
                state.postDetail = {...action.payload, isLiked:action.payload?.isLiked ||false};
            })
            .addCase(fetchSinglepost.rejected, (state, action) => {
                state.isLoading = false;
                state.postDetail ={};
                state.isError = true;
                state.error = action.error?.message;
            });
    },
});

export default singlePostSlice.reducer;